import React from "react";
import { translate } from "react-i18next";
import PropTypes from "prop-types";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import DialogTitle from "@material-ui/core/DialogTitle";
// import Dialog from '../../components/dialog'
import { withStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";

const dialogStyles = (theme) => ({
  paper: {
    minWidth: 300,
  },
  title: {
    color: "#263238",
    fontSize: "16px",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: "500",
    lineHeight: "20px",
    letterSpacing: "-0.05px",
  },
  content: {
    color: "#263238",
    fontSize: "14px",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: "400",
    lineHeight: "21px",
    letterSpacing: "-0.05px",
  },
  containerContent: {
    padding: "16px 4px 0",
  },
  containerAction: {
    padding: "16px 24px",
  },
});
export const Transition = React.forwardRef((props, ref) => (
  <Slide direction="down" {...props} />
));
class AlertDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      t,
      classes,
      open,
      content = t("do_you_want_delete"),
      onClose,
      onSubmit,
    } = this.props;
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          <Typography variant="h5" className={classes.title}>
            {t("notice")}
          </Typography>
        </DialogTitle>
        <>
          <Divider />

          <DialogContent>
            <DialogContentText
              id="alert-dialog-slide-description"
              className={classes.containerContent}
            >
              <Typography variant="h5" className={classes.content}>
                {content}
              </Typography>
            </DialogContentText>
          </DialogContent>
        </>

        <Divider />
        <DialogActions className={classes.containerAction}>
          <Button onClick={onClose} color="default">
            {t("disagree")}
          </Button>
          <Button onClick={onSubmit} variant="contained" color="primary">
            {" "}
            {t("agree")}
          </Button>
        </DialogActions>
      </Dialog>
      // <Dialog
      //     open={open}
      //     onClose={onClose}
      //     aria-labelledby="alert-dialog-title"
      //     aria-describedby="dialog-delete"
      //     classes={{
      //         paper: classes.paper
      //     }}
      // >
      //     <DialogTitle id="dialog-delete" className={classes.title}>

      //     {t('notice')}</DialogTitle>
      //     <DialogContent>
      //         <DialogContentText id="dialog-delete">{content}</DialogContentText>
      //     </DialogContent>
      //     <DialogActions>
      //         <Button onClick={onClose} color="primary">
      //             {t('disagree')}
      //         </Button>
      //         <Button onClick={onSubmit} color="primary" autoFocus>
      //             {t('agree')}
      //         </Button>
      //     </DialogActions>
      // </Dialog>
    );
  }
}

AlertDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
export default translate("translations")(
  withStyles(dialogStyles, { withTheme: true })(AlertDialog)
);
